import { IconWrapper } from '../runtime';
export default IconWrapper('indent-increase', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 2.24927H14.2539M1.75 7.99927H9.24609M1.75 13.7493H14.2539M12.25 5.99976L14.25 7.99951L12.25 9.99976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});